var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold caption ml-2",attrs:{"x-small":_vm.xsmall,"small":_vm.small,"outlined":"","color":_vm.prioridade.cor}},[_vm._v(_vm._s(_vm.prioridade.descricao)+" "),_c('v-icon',{attrs:{"x-small":"","right":""}},[_vm._v(_vm._s(_vm.prioridade.icone))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }